class FjHeaderMobile {
  constructor() {
    this.mobile = document.querySelector('[data-fj-mobile-nav]');

    if (!this.mobile) return;

    this.toggle = document.querySelector('[data-fj-mobile-toggle]');
    this.closeButtons = this.mobile.querySelectorAll('[data-fj-mobile-close]');
    this.overlay = this.mobile.querySelector('[data-fj-mobile-overlay]');
    this.openPanelButtons = this.mobile.querySelectorAll('[data-fj-open-panel]');
    this.backButtons = this.mobile.querySelectorAll('[data-fj-back]');
    this.panels = this.mobile.querySelectorAll('[data-panel]');

    this.cartLinks = document.querySelectorAll('[data-fj-cart-link]');
    this.cartCounts = this.mobile.querySelectorAll('[data-fj-cart-count]');
    this.cartTotals = this.mobile.querySelectorAll('[data-fj-cart-total]');
    this.wishlistLinks = document.querySelectorAll('[data-fj-wishlist-link]');
    this.wishlistCounts = this.mobile.querySelectorAll('[data-fj-wishlist-count]');
    this.mobileQuery = window.matchMedia('(max-width: 989px)');

    /* Liquid rendered the counts hidden when empty, so the initial
       state can be read straight off the markup. */
    this.cartEmpty = this.cartCounts[0]?.hasAttribute('hidden') ?? true;
    this.wishlistEmpty = this.wishlistCounts[0]?.hasAttribute('hidden') ?? true;

    this.events();
  }

  events() {
    // Open drawer
    this.toggle?.addEventListener('click', () => {
      this.open();
    });

    // Close button
    this.closeButtons.forEach((button) => {
      button.addEventListener('click', () => {
        this.close();
      });
    });

    // Overlay close
    this.overlay?.addEventListener('click', () => {
      this.close();
    });

    // Open child panel
    this.openPanelButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const panel = button.dataset.fjOpenPanel;
        this.showPanel(panel);
      });
    });

    // Back button
    this.backButtons.forEach((button) => {
      button.addEventListener('click', () => {
        this.showPanel('root');
      });
    });

    /* Cart and wishlist links navigate when there is something to show,
       and open the empty panel when there is not. */
    this.cartLinks.forEach((link) => {
      link.addEventListener('click', (event) => {
        if (!this.mobileQuery.matches) return;

        /* Below 990px the cart icon never opens the side drawer:
           it goes to the cart page, or shows the empty panel. */
        event.stopPropagation();
        if (!this.cartEmpty) return;

        event.preventDefault();
        this.open();
        this.showPanel('cart-empty');
      });
    });

    this.wishlistLinks.forEach((link) => {
      link.addEventListener('click', (event) => {
        if (!this.mobileQuery.matches || !this.wishlistEmpty) return;

        event.preventDefault();
        this.open();
        this.showPanel('wishlist-empty');
      });
    });

    document.addEventListener('fj:cart:updated', (event) => {
      this.updateCart(event.detail.cart);
    });

    document.addEventListener('fj:wishlist:updated', (event) => {
      this.updateWishlist(event.detail.count);
    });
  }

  updateCart(cart) {
    if (!cart) return;

    this.cartEmpty = cart.item_count === 0;

    this.cartCounts.forEach((element) => {
      element.textContent = `(${cart.item_count})`;
      element.toggleAttribute('hidden', this.cartEmpty);
    });

    this.cartTotals.forEach((element) => {
      element.textContent = this.formatMoney(cart.total_price);
      element.toggleAttribute('hidden', this.cartEmpty);
    });

    /* The empty panel is wrong the moment the cart stops being empty. */
    if (!this.cartEmpty && this.mobile.dataset.activePanel === 'cart-empty') {
      this.showPanel('root');
    }
  }

  updateWishlist(count) {
    this.wishlistEmpty = count === 0;

    this.wishlistCounts.forEach((element) => {
      element.textContent = `(${count})`;
      element.toggleAttribute('hidden', this.wishlistEmpty);
    });

    if (!this.wishlistEmpty && this.mobile.dataset.activePanel === 'wishlist-empty') {
      this.showPanel('root');
    }
  }

  formatMoney(cents) {
    const format = this.mobile.getAttribute('data-fj-money-format') || '${{amount}}';
    const amount = (cents / 100)
      .toFixed(2)
      .replace(/\B(?=(\d{3})+(?!\d))/g, ',');

    /* money_format is a template like "${{amount}}" or "${{amount}} CAD",
       so substitute into it rather than assuming a dollar sign. */
    return format.replace(/\{\{\s*amount[^}]*\}\}/, amount);
  }

  open() {
    this.mobile.classList.add('fj-header-mobile--open');
    document.body.classList.add('fj-no-scroll');
    this.toggle?.setAttribute('aria-expanded', 'true');
  }

  close() {
    this.mobile.classList.remove('fj-header-mobile--open');
    document.body.classList.remove('fj-no-scroll');
    this.toggle?.setAttribute('aria-expanded', 'false');

    // reset menu when closing
    this.showPanel('root');
  }

    showPanel(panelId) {
      let activePanel = null;

      this.panels.forEach((panel) => {
        const isActive = panel.dataset.panel === panelId;
        panel.classList.toggle('fj-header-mobile__panel--active', isActive);
        if (isActive) activePanel = panel;
      });

      this.mobile.dataset.activePanel = panelId;

      const showBack =
        panelId !== 'root' &&
        !activePanel?.classList.contains('fj-header-mobile__panel--utility');

      this.mobile.classList.toggle('fj-header-mobile--has-back', showBack);
    }
}

document.addEventListener('DOMContentLoaded', () => {
  new FjHeaderMobile();
});